import { useState, useLayoutEffect } from 'react'
import { AssetReference } from '@opallabs/cassini'
import type { SectionOptionProps } from '../../types'

interface SortedOptionsReturn {
  sortedOptions: SectionOptionProps[]
  sortedGroupedOptions: SectionOptionProps[][]
}

export function useSortedOptions(
  options: SectionOptionProps[],
  sections: (AssetReference | string | null)[],
  index: number
): SortedOptionsReturn {
  const [sortedOptions, setSortedOptions] =
    useState<SectionOptionProps[]>(options)
  const [sortedGroupedOptions, setSortedGroupedOptions] = useState<
    SectionOptionProps[][]
  >([])

  useLayoutEffect(() => {
    let newSortedOptions = options.sort((a, b) => {
      if (a.option === 'section position') return -1
      else if (b.option === 'section position') return 1
      else return a.option > b.option ? 1 : -1
    })
    const allGroupedOptions = newSortedOptions.filter((option) => option.group)
    newSortedOptions = newSortedOptions.filter((option) => !option.group)

    const newGroupedOptions: SectionOptionProps[][] = []
    if (allGroupedOptions.length > 0) {
      const reducedOptions = allGroupedOptions.reduce(
        (acc: { [key: number]: SectionOptionProps[] }, option) => {
          const key = option.group_id || 0
          if (!acc[key]) {
            acc[key] = []
          }
          acc[key].push(option)
          return acc
        },
        {}
      )
      Object.entries(reducedOptions).forEach((option) =>
        newGroupedOptions.push(option[1])
      )
    }

    setSortedGroupedOptions(newGroupedOptions)
    setSortedOptions(newSortedOptions)
  }, [index, options, sections])

  return { sortedOptions, sortedGroupedOptions }
}
